import { render } from "./naik-pangkat-prediksi-list-custom.vue?vue&type=template&id=63fa14dd"
import script from "./naik-pangkat-prediksi-list-custom.vue?vue&type=script&lang=js"
export * from "./naik-pangkat-prediksi-list-custom.vue?vue&type=script&lang=js"

import "./naik-pangkat-prediksi-list-custom.vue?vue&type=style&index=0&id=63fa14dd&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__